module.exports = __webpack_public_path__ + "static/image/sustainability/m/ethical@3x.ver2_0_2.jpg?f50209fd";